import React, { useState } from 'react';

const ImageWithFallback = ({ src, alt, fallbackSrc, ...props }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [imageLoaded, setImageLoaded] = useState(false);
    const isFallback = fallbackSrc && (imgSrc === fallbackSrc || imgSrc?.includes('head.svg') || imgSrc?.includes('Companies-No-Image.svg'));
    
    const handleError = () => {
        setImgSrc(fallbackSrc);
        setImageLoaded(true); // Show fallback immediately
    };

    const handleLoad = (e) => {
        setImageLoaded(true);
        if (e.target) {
            e.target.style.opacity = '1';
            e.target.classList.add('loaded');
        }
    };

    const imageStyle = {
        ...props.style,
        opacity: imageLoaded || isFallback ? 1 : (props.style?.opacity || 0),
        transition: 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
    };

    return (
        <img
            src={imgSrc}
            alt={alt}
            onError={handleError}
            onLoad={handleLoad}
            {...props}
            style={imageStyle}
        />
    );
};

// Usage Example
const ImageWithPlaceholder = ({ src, style, className, width, height, fallbackSrc, isKjuup = false }) => {
    // Using outline with outlineOffset to create a 1px gap between avatar and green ring
    const imageStyle = {
        ...style,
        border: style?.border || "none",
        ...(isKjuup ? {
            outline: "2px solid var(--kjuup-internal)",
            outlineOffset: "2px"
        } : {})
    };
    return (
        <div>
            <ImageWithFallback
                src={src}
                fallbackSrc={fallbackSrc}
                width={height}
                height={width}
                className={className}
                style={imageStyle}
            />
        </div>
    );
};

export default ImageWithPlaceholder;
